import { Injectable } from "@angular/core";
import { Observable, Subject, Subscriber, tap } from "rxjs";
import { Addon } from "../models/addon.model";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class TechnadoptAuthService {
  private refreshTokenInProgress = false;
  private tokenRefreshed$: Subject<Addon> = new Subject();

  constructor(private authService: AuthService) { }

  public refreshToken(taAddon: Addon) {
    if (this.refreshTokenInProgress) {
      return new Observable((observer: Subscriber<Addon>) => {
        this.tokenRefreshed$.subscribe((addon) => {
          observer.next(addon);
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;
      return this.authService
        .getTechnadoptAuthorizedTokenIfRequired(taAddon, this.authService.idenediGroupId)
        .pipe(
          tap((addon) => {
            this.refreshTokenInProgress = false;
            this.tokenRefreshed$.next(addon);
          })
        );
    }
  }
}
